<template>
  <div class="environment-grid">
    <div
      v-for="environment in environments"
      :key="environment.id"
      class="image-outer"
    >
      <div class="image-inner" @click="selectEnvironment(environment)">
        <div
          class="thumbnail-wrapper"
          :class="{ 'thumbnail-selected': environment.key === selectedEnvironment }"
          :aria-label="`${environment.name.en} Thumbnail`"
          :data-testid="`thumbnail-${environment.key}`"
        >
          <img
            :src="pictureFor(environment)"
            class="thumbnail-img"
            :alt="environment.name.en"
          >
        </div>
        <div class="scene-label">
          <span>{{ environment.name.en }}</span>
          <help-tooltip
            v-if="stanceRestriction(environment)"
            class="stance-badge"
            direction="top"
            :data-testid="`stance-badge-${environment.key}`"
          >
            <template #trigger>
              <img
                :src="stanceIcon(environment)"
                class="stance-icon"
                alt=""
              >
            </template>
            {{ stanceLabel(environment) }}
          </help-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

const seatedIcon = require('@/assets/icons/seated.svg');
const standingIcon = require('@/assets/icons/standing.svg');

export default {
  name: 'environment-grid',
  components: { HelpTooltip },
  props: {
    environments: {
      type: Array,
      default: () => []
    },
    selectedEnvironment: {
      type: String,
      default: null,
    },
  },
  methods: {
    pictureFor(location) {
      return get(location, 'picture.url', 'http://icons.iconarchive.com/icons/papirus-team/papirus-status/512/image-missing-icon.png');
    },
    selectEnvironment(environment) {
      this.$emit('select', environment)
    },
    stanceRestriction(environment) {
      const stances = environment.availableNpcStances;
      if (!stances || stances.length !== 1) return null;
      if (stances[0] === 'CHAIR') return 'seated';
      if (stances[0] === 'STAND') return 'standing';
      return null;
    },
    stanceIcon(environment) {
      return this.stanceRestriction(environment) === 'seated' ? seatedIcon : standingIcon;
    },
    stanceLabel(environment) {
      return this.stanceRestriction(environment) === 'seated'
        ? 'VIP is seated-only in this scene'
        : 'VIP is standing-only in this scene';
    },
  }
}
</script>

<style scoped>
.environment-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* automatically spaces between items, but no gap on the outer edge */
}

.image-outer {
  display: inline-block;
}

.image-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.thumbnail-wrapper {
  aspect-ratio: 1 / 1;
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin-bottom: 10px;
}

.thumbnail-selected {
  outline: 4px solid #3f83c5;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}

.scene-label {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  line-height: 18px;
  width: 160px;
}

.stance-badge {
  flex-shrink: 0;
  line-height: 0;
  cursor: default;
}

.stance-icon {
  width: 28px;
  height: 28px;
  display: block;
  margin-top: -6px;
}

</style>
